<template>
  <div class="card">
    <div class="card-body">
      <h5 class="card-title">Хувийн мэдээлэл</h5>
      <table class="table" v-if="user">
        <tbody>
          <tr>
            <td>{{ __('001_common.user.lastname') }}, {{ __('001_common.user.firstname') }}</td>
            <td>{{ user.lastname }} {{ user.firstname }}</td>
          </tr>
          <tr>
            <td>{{ __('001_common.user.registernum') }}</td>
            <td>{{ user.register_number }}</td>
          </tr>
          <tr>
            <td>{{ __('001_common.user.bank_name') }}</td>
            <td>{{ user.bank_name }}</td>
          </tr>
          <tr>
            <td>{{ __('001_common.user.account_number') }}</td>
            <td>{{ user.account_number }}</td>
          </tr>
          <tr>
            <td>{{ __('001_common.user.bank_account_holder') }}</td>
            <td>{{ user.bank_account_holder }}</td>
          </tr>
          <tr>
            <td>Шимтгэл</td>
            <td>{{ user.fee }}</td>
          </tr>
          <tr>
            <td>{{ __('001_common.user.birthday') }}</td>
            <td>{{ user.birthday }}</td>
          </tr>
          <tr>
            <td>{{ __('001_common.user.email') }}</td>
            <td>{{ user.email }}</td>
          </tr>
          <tr>
            <td>{{ __('001_common.user.mobilenumber') }}</td>
            <td>{{ user.mobilenumber }}</td>
          </tr>
          <tr>
            <td>Гэрийн утас</td>
            <td>{{ user.homephonenumber }}</td>
          </tr>
          <tr>
            <td>Татвар төлөгчийн дугаар</td>
            <td>{{ user.taxnumber }}</td>
          </tr>
          <tr>
            <td>Хөрөнгө оруулалтын зорилго</td>
            <td>{{ user.purpose_of_investment }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  methods: {
    trans(key) {
      return key;
    }
  }
}
</script>
